/**
 * Checks if a string contains 'fragments'
 * @param {str} key
 */
const isFragment = key => ~key.indexOf('fragments.');

/**
 * Reduces a hash string to an object
 * @param {Object} hashObj
 * @param {String} str
 */
const reducer = (hashObj, str) => {
  let [key, value] = str.split('='); //eslint-disable-line

  key = decodeURIComponent(key);
  value = decodeURIComponent(value);

  if (isFragment(key)) {
    hashObj.facets.push({
      name: key,
      value
    });
  } else {
    hashObj[key] = value;
  }

  return hashObj;
};

/**
 * Takes a hash string and returns an object with keys/values
 * @param {String} hash
 * @param {Number} trimStart
 * @returns {Object}
 */
export default (hash, trimStart = 1) => {
  if (hash === '' || hash === undefined) return {};

  const splitHash = hash.slice(trimStart).split('&');

  return splitHash.reduce(reducer, {
    facets: []
  });
};
